/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Featured_Card_ContentInputs */

const en_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Time Crystals, and 600 coins`)
};

const ar_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie، 30 من «بلورة الزمن» و600 عملة`)
};

const de_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Time Crystals und 600 Münzen`)
};

const es_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 cristales de tiempo y 600 monedas`)
};

const fr_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristaux de temps et 600 pièces`)
};

const it_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristalli del Tempo e 600 monete`)
};

const ja_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、時の結晶30個、コイン600枚`)
};

const ko_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 타임 크리스탈 30개, 코인 600개`)
};

const pt_br_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristais do Tempo e 600 moedas`)
};

const ru_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, «Кристальное Время» × 30 и 600 монет`)
};

const th_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, คริสตัลแห่งกาลเวลา 30 ชิ้น และเหรียญ 600 เหรียญ`)
};

const tr_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, Zaman Kristalleri × 30 ve 600 jeton`)
};

const zh_cn_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、30 时光宝石与 600 金币`)
};

const zh_tw_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、30 時光寶石與 600 金幣`)
};

/**
* | output |
* | --- |
* | "Luminie, 30 Time Crystals, and 600 coins" |
*
* @param {Starter_Pack_Featured_Card_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_featured_card_content = /** @type {((inputs?: Starter_Pack_Featured_Card_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Featured_Card_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_featured_card_content(inputs)
	if (locale === "ar") return ar_starter_pack_featured_card_content(inputs)
	if (locale === "de") return de_starter_pack_featured_card_content(inputs)
	if (locale === "es") return es_starter_pack_featured_card_content(inputs)
	if (locale === "fr") return fr_starter_pack_featured_card_content(inputs)
	if (locale === "it") return it_starter_pack_featured_card_content(inputs)
	if (locale === "ja") return ja_starter_pack_featured_card_content(inputs)
	if (locale === "ko") return ko_starter_pack_featured_card_content(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_featured_card_content(inputs)
	if (locale === "ru") return ru_starter_pack_featured_card_content(inputs)
	if (locale === "th") return th_starter_pack_featured_card_content(inputs)
	if (locale === "tr") return tr_starter_pack_featured_card_content(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_featured_card_content(inputs)
	return zh_tw_starter_pack_featured_card_content(inputs)
});